<template>
	<div class="box">
		<div>
			<div class="numDoctor">
				<div class="text1">
					<p>粉丝授权总数</p>
					<p>{{yhorow.yhtsq}}</p>
				</div>
				<div class="text2">
					<p>昨日新增</p>
					<p>{{yhorow.yhtsq_jt}}</p>
				</div>
				<div class="text2">
					<p>七日新增</p>
					<p>{{yhorow.yhtsq_7t}}</p>
				</div>
			</div>
			<div class="chartsDoc">
				<div class="chartsDocheader">
					<div>
						<el-date-picker
						    v-model="value2"
						    type="daterange"
						    range-separator="至"
						    start-placeholder="开始月份"
						    end-placeholder="结束月份"
						    value-format="yyyy-MM-dd"
						    @blur="date1Fn()">
						    </el-date-picker>
					</div>
					<div class="datebtn">
						<div :class="btn1Str==7?'active':''" @click="day1Fn(7)">近7日</div>
						<div :class="btn1Str==30?'active':''" @click="day1Fn(30)">近30日</div>
					</div>
				</div>
				<div class="chartsDoccontent">
					<div>
						<zxxyEchart :type="2" :options1="options1" :dates="value2"  :name="name1" :zsoption="sqltop"></zxxyEchart>

					</div>
					<div>
						<zxxyEchart :type="2" :options1="options1" :dates="value2"  :name="name2" :zsoption="sqllast" ></zxxyEchart>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {user_count,yht_wmp_sqtj,yht_sqlyy_top10,yht_sqlyy_last10,yht_tj} from '../components/http/api.js'
	import zxEchart from '../component/zxEchart.vue'
	import zxxyEchart from '../component/zxxyEchart.vue'
	export default{
		components:{
			zxEchart,
			zxxyEchart
		},
		data(){
			return{
				value2:'',
				value1:1,
				options1:[{
					id:'1',
					name:'正畸诊断报告',
				},{
					id:'2',
					name:'患者健康检查报告',
				},{
					id:'3',
					name:'患者沟通报告',
				},{
					id:'4',
					name:'正畸治疗对比报告',
				}],
				options2:[{
					id:1,
					name:'专家审阅',
				},{
					id:2,
					name:'分享案例',
				}],
				hzNum:'',
				name1:'粉丝量Top10牙医',
				name2:'粉丝量Last10牙医',
				sqltop:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		                data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '粉丝量',
		                type: 'bar',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)']
		        },
		        sqllast:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		                data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '粉丝量',
		                type: 'bar',
		                data: [0,0,0,0],
		            }],
		            color: ['rgba(29,181,255,1)']
		        },
		        btn1Str:7,
		        yhorow:{}
			}
		},
		beforeMount() {
			this.yht_tjFn();
			this.value2=[this.getDay(-7),this.getDay(-1)];
			this.yht_sqlyy_top10Fn();
			this.yht_sqlyy_last10Fn();
		},
		methods:{
			date1Fn(){
				this.yht_sqlyy_top10Fn();
				this.yht_sqlyy_last10Fn();
			},
			day1Fn(i){
				this.btn1Str=i;
				this.value2=[this.getDay(-i),this.getDay(-1)];
				this.yht_sqlyy_top10Fn();
				this.yht_sqlyy_last10Fn();
			},
			yht_tjFn(){
				yht_tj().then(res=>{
					this.yhorow=res;
				})
			},
			getDay(day){
			    var today = new Date();
			    var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
			    today.setTime(targetday_milliseconds); //注意，这行是关键代码
			    var tYear = today.getFullYear();
			    var tMonth = today.getMonth();
			    var tDate = today.getDate();
			    tMonth = this.doHandleMonth(tMonth + 1);
			    tDate = this.doHandleMonth(tDate);
			    return tYear+"-"+tMonth+"-"+tDate;
			},
			doHandleMonth(month){
			    var m = month;
			    if(month.toString().length == 1){
			     m = "0" + month;
			    }
			    return m;
			},
			yht_sqlyy_top10Fn(){
				var data={
					start_time:this.value2[0],
					end_time:this.value2[1]
				}
				yht_sqlyy_top10(data).then(res=>{
					var arr1=res.ay_name;
					var arr2=res.ay_data;
					this.sqltop.xAxis.data=arr1;
					this.sqltop.series[0].data=arr2;
				})
			},
			yht_sqlyy_last10Fn(){
				var data={
					start_time:this.value2[0],
					end_time:this.value2[1]
				}
				yht_sqlyy_last10(data).then(res=>{
					var arr1=res.ay_name;
					var arr2=res.ay_data;
					this.sqllast.xAxis.data=arr1;
					this.sqllast.series[0].data=arr2;
				})
			},
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: 100%;
	}
	.box>div{
		height: 364px;
		width: 100%;
		display: flex;
		justify-content: space-between;
		/*background: #FFFFFF;*/
	}
	
	.box>div:nth-child(1){
		margin-bottom: 7px;
	}
	.numDoctor{
		width: 212px;
		height: 344px;
		padding:10px 20px;
		border-radius:3px;
		/*border-right: 3px solid rgba(198,198,198,1);*/
		background: #FFFFFF;
	}
	.text1,.text2{
		margin-bottom: 30px;
	}
	.text1>p:nth-child(1){
		font-size:15px;
		font-weight:400;
		color:rgba(74,74,74,1);
		line-height:23px;
	}
	.text1>p:nth-child(2){
		font-size:30px;
		font-weight:600;
		color:rgba(74,74,74,1);
		margin-top: 8px;
		line-height:23px;
	}
	.text2>p:nth-child(1){
		font-size:15px;
		font-weight:400;
		color:rgba(74,74,74,1);
		line-height:23px;
	}
	.text2>p:nth-child(2){
		margin-top: 8px;
		font-size:30px;
		font-weight:600;
		color:rgba(29,181,255,1);
		line-height:23px;
	}
	.chartsDoc{
		width:1035px;
		height:344px;
		padding: 10px 20px;
		background:rgba(255,255,255,1);
		border-radius:3px;
		
	}
	.chartsDocheader{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.chartsDocheader>div:nth-child(1){
		width: 400px;
	}
	.chartsDocheader>div:nth-child(1)>div{
		width: 400px;
	}
	.datebtn>div:hover{
		border:1px solid yellow;
		
	}
	.datebtn{
		display: flex;
	}
	.datebtn>div{
		margin-right: 13px;
		cursor: pointer;
		width:93px;
		height:42px;
		background:rgba(234,234,234,1);
		border-radius:24px;
		border:1px solid rgba(221,227,232,1);
		font-size:19px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(155,155,155,1);
		line-height:24px;
		display: flex;justify-content: center;
		align-items: center;
	}
	.datebtn>div.active{
		font-size:19px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(255,255,255,1);
		line-height:24px;
		background:rgba(29,181,255,1);
	}
	.chartsDoccontent{
		display: flex;
		justify-content: space-between;
	}
	.chartsDoccontent>div{
		width:497px;
		height: 290px;
		margin-top: 10px;
		/*background: #CCCCCC;*/
	}
	
</style>


// WEBPACK FOOTER //
// src/component/hzDate.vue